import { FORGOT_PIN_STEP_NAMES } from './constants';

export const stepsNavigation = ({
    stepName,
    isErrorStepFromSecretsQuestionStep
}: { stepName: FORGOT_PIN_STEP_NAMES; isErrorStepFromSecretsQuestionStep?: boolean }) => {
    switch (stepName) {
        case FORGOT_PIN_STEP_NAMES.SECRETS_QUESTION_STEP:
            return FORGOT_PIN_STEP_NAMES.USER_INFO_STEP;

        case FORGOT_PIN_STEP_NAMES.FORGOT_SECRET_ANSWER_STEP:
            return FORGOT_PIN_STEP_NAMES.SECRETS_QUESTION_STEP;

        case FORGOT_PIN_STEP_NAMES.FAILED_STEP:
            return isErrorStepFromSecretsQuestionStep
                ? FORGOT_PIN_STEP_NAMES.SECRETS_QUESTION_STEP
                : FORGOT_PIN_STEP_NAMES.USER_INFO_STEP;

        case FORGOT_PIN_STEP_NAMES.SUCCESSFUL_STEP:
            return FORGOT_PIN_STEP_NAMES.SECRETS_QUESTION_STEP;

        default:
            return FORGOT_PIN_STEP_NAMES.USER_INFO_STEP;
    }
};

